export default {
  seenIdListKey: '_lfns',
  notificationCacheKey: '_lfns_cache',
};
